module.exports = __webpack_public_path__ + "static/img/womendefuwu.6045748.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/womendefuwu.png
// module id = AJwg
// module chunks = 0